import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconFileArchive = (props) => {
  const { fontSize = '1.5rem', color = 'text.disabled', filled = true, ...other } = props;

  if (!filled) {
    console.debug('IconFileArchive needs to be created also as outlined icon');
  }

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.0134 5.00576C20.5605 5.00576 21.0307 5.1977 21.4242 5.59117H21.4146C21.8081 5.98465 22 6.45489 22 7.00192V18.1823C22 18.7294 21.8081 19.1996 21.4146 19.5931C21.0211 19.9866 20.5509 20.1785 20.0038 20.1785H3.99616C3.44914 20.1785 2.97889 19.9866 2.58541 19.5931C2.19194 19.1996 2 18.7294 2 18.096V4.91939C2 4.44914 2.19194 3.97889 2.58541 3.58541C2.97889 3.19194 3.44914 3 3.99616 3H8.17083L10.1766 5.00576H12.1536V6.92514H10.2342V8.84453H12.1536V10.7351H10.2342V12.6545C10.0422 13.7678 9.97505 14.8426 9.97505 15.3321C9.97505 16.5317 10.9539 17.5106 12.1536 17.5106C13.3532 17.5106 14.3321 16.5317 14.3321 15.3321C14.3321 14.8426 14.2361 13.7678 14.0345 12.6641L14.0729 8.84453H12.1536V6.92514H14.0729V5.00576H20.0134ZM12.1535 16.2918C11.6736 16.2918 11.2802 15.8983 11.2802 15.4185C11.2802 14.9386 11.6736 14.5451 12.1535 14.5451C12.6333 14.5451 13.0268 14.9386 13.0268 15.4185C13.0268 15.8983 12.6333 16.2918 12.1535 16.2918Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

IconFileArchive.propTypes = {
  color: PropTypes.string,
  filled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconFileArchive;
